<div class="panel panel-default">
  <div class="panel-body padding-small">
    <div class="grid-1">
      <h2 class="mt-02">{{ config.ItineraryStepDocumentConfig.Description }}</h2>

      <label class="control control-checkbox" style="cursor: pointer" [title]="!config.ItineraryStepDocumentConfig.OptionalOnDistribution ? 'This step is not optional on and must be configured' : 'This step is optional and can be enabled or disabled here'">
        Enabled
        <input type="checkbox" [disabled]="!config.ItineraryStepDocumentConfig.OptionalOnDistribution"  [(ngModel)]="config.Enabled" />
        <i></i>
      </label>
    </div>
    @if (config.ItineraryStepDocumentConfig.ConfigureOnDistribution && config.Enabled) {
      <div>
        <div class="row">
          <div class="col-md-6">
            <button class="btn btn-link padding-small" (click)="showConfiguration = !showConfiguration">{{ showConfiguration ? 'Hide configuration' : 'Show configuration' }}</button>
          </div>
          <div class="col-md-6">
            @if (!isValid) {
              <p class="error">
                <small>Some settings needs attention</small>
              </p>
            }
          </div>
        </div>
        <div [hidden]="!showConfiguration">
          <ep-datafield-group-container #groupContainer
            [numberOfColumns]="1"
            [datafieldGroups]="config.DataFieldGroups"
            [isAlwaysEditable]="true"
            [formValidationGroup]="formGroup">
          </ep-datafield-group-container>
        </div>
      </div>
    }
  </div>
</div>
